import { Tooltip } from 'uikit';

import type { CustomHeaderProps } from 'ag-grid-react';
import type { CSSProperties, ReactNode } from 'react';
import { useCallback, useRef, useState } from 'react';

interface ITitleWithTooltipColumnsProps extends CustomHeaderProps {
    title: ReactNode;
    childTooltip?: ReactNode;
    style?: CSSProperties;
}

export const TitleWithTooltipColumns = (props: Partial<ITitleWithTooltipColumnsProps>) => {
    const { title, childTooltip, style, showColumnMenu, enableFilterButton } = props;

    const titleRef = useRef(null);
    const [isOpenTooltip, setIsOpenTooltip] = useState<boolean>(false);

    const handleMouseMoveButton = useCallback(() => {
        setIsOpenTooltip(true);
    }, []);

    const handleMouseLeaveButton = useCallback(() => {
        setIsOpenTooltip(false);
    }, []);

    const openFilter = useCallback(() => {
        if (titleRef?.current) {
            showColumnMenu?.(titleRef.current);
        }
    }, [showColumnMenu]);

    return (
        <>
            <div ref={titleRef} onMouseMove={handleMouseMoveButton} onMouseLeave={handleMouseLeaveButton} style={style}>
                {title}
            </div>
            {enableFilterButton && (
                <span
                    role="presentation"
                    onClick={openFilter}
                    data-ref="eFilterButton"
                    className="ag-header-icon ag-header-cell-filter-button"
                >
                    <svg
                        style={{
                            cursor: 'pointer',
                            width: '24px',
                            height: '24px',
                        }}
                        viewBox="0 0 24 25"
                        fill="none"
                    >
                        <path
                            d="M18 6.5H6V7.7759C6 8.24377 6.16403 8.69684 6.46356 9.05627L10.5364 13.9437C10.836 14.3032 11 14.7562 11 15.2241V19.5L13 18.5V15.2241C13 14.7562 13.164 14.3032 13.4636 13.9437L17.5364 9.05627C17.836 8.69684 18 8.24377 18 7.7759V6.5Z"
                            fill="#00395C"
                            fillOpacity="0.8"
                        />
                    </svg>
                </span>
            )}
            {childTooltip && isOpenTooltip && (
                <Tooltip size="s" direction="upCenter" anchorRef={titleRef} isInteractive={false}>
                    {childTooltip}
                </Tooltip>
            )}
        </>
    );
};

TitleWithTooltipColumns.displayName = 'TitleWithTooltipColumns';
